import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useStore } from 'react-redux';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CounterCard from '../../../../components/CounterCard';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import AdjustIcon from '@material-ui/icons/Adjust'; // Example for Partial
import AssignmentReturnIcon from '@material-ui/icons/AssignmentReturn';
import HistoryIcon from '@material-ui/icons/History'; // Example for All Delivered/Returned/Partial

const useStyles = makeStyles({
  ON_DELIVERY: { backgroundColor: '#ffeb3b', color: '#000' },
  DELIVERED_BY_RIDER: { backgroundColor: '#4caf50', color: '#fff' },
  PARTIALLY_DELIVERED_BY_RIDER: { backgroundColor: '#ff9800', color: '#fff' },
  RETURNED_BY_RIDER: { backgroundColor: '#f44336', color: '#fff' },
  DELIVERED: { backgroundColor: '#2196f3', color: '#fff' },
  RETURNED: { backgroundColor: '#9c27b0', color: '#fff' },
  PARTIALLY_DELIVERED: { backgroundColor: '#ffc107', color: '#000' },
});

export default function Dashboard() {
  const classes = useStyles();
  const store = useStore();
  const [get_table_data, set_table_data]: any = useState([]);

  async function fetchAPI() {
    const auth = {
      headers: {
        Authorization: `Bearer ${store.getState().auth.jwt}`,
      },
    };
    await Promise.all([
      axios.get(`${process.env.REACT_APP_API_SERVER}/parcels/count?status=ON_DELIVERY`, auth),
      axios.get(`${process.env.REACT_APP_API_SERVER}/parcels/count?status=DELIVERED_BY_RIDER`, auth),
      axios.get(`${process.env.REACT_APP_API_SERVER}/parcels/count?status=PARTIALLY_DELIVERED_BY_RIDER`, auth),
      axios.get(`${process.env.REACT_APP_API_SERVER}/parcels/count?status=RETURNED_BY_RIDER`, auth),
      axios.get(`${process.env.REACT_APP_API_SERVER}/parcels/count?status=DELIVERED`, auth),
      axios.get(`${process.env.REACT_APP_API_SERVER}/parcels/count?status=RETURNED`, auth),
      axios.get(`${process.env.REACT_APP_API_SERVER}/parcels/count?status=PARTIALLY_DELIVERED`, auth),
    ]).then(
      ([
        ON_DELIVERY,
        DELIVERED_BY_RIDER,
        PARTIALLY_DELIVERED_BY_RIDER,
        RETURNED_BY_RIDER,
        DELIVERED,
        RETURNED,
        PARTIALLY_DELIVERED,
      ]) => {
        set_table_data([
          {
            status: 'ON_DELIVERY',
            count: ON_DELIVERY.data,
            label: 'On Delivery',
            link: '/dashboard/parcel?status_in=ON_DELIVERY',
            icon: <LocalShippingIcon />,
          },
          {
            status: 'DELIVERED_BY_RIDER',
            count: DELIVERED_BY_RIDER.data,
            label: 'Delivered',
            link: '/dashboard/parcel?status_in=DELIVERED_BY_RIDER',
            icon: <CheckCircleIcon />,
          },
          {
            status: 'PARTIALLY_DELIVERED_BY_RIDER',
            count: PARTIALLY_DELIVERED_BY_RIDER.data,
            label: 'Partially Delivered', // Corrected typo
            link: '/dashboard/parcel?status_in=PARTIALLY_DELIVERED_BY_RIDER',
            icon: <AdjustIcon />,
          },
          {
            status: 'RETURNED_BY_RIDER',
            count: RETURNED_BY_RIDER.data,
            label: 'Returned',
            link: '/dashboard/parcel?status_in=RETURNED_BY_RIDER',
            icon: <AssignmentReturnIcon />,
          },
          {
            status: 'DELIVERED',
            count: DELIVERED.data,
            label: 'All Delivered',
            link: '/dashboard/history?status_in=DELIVERED',
            icon: <HistoryIcon />,
          },
          {
            status: 'RETURNED',
            count: RETURNED.data,
            label: 'All Returned',
            link: '/dashboard/history?status_in=RETURNED',
            icon: <HistoryIcon />,
          },
          {
            status: 'PARTIALLY_DELIVERED',
            count: PARTIALLY_DELIVERED.data,
            label: 'All Partially Del.',
            link: '/dashboard/history?status_in=PARTIALLY_DELIVERED',
            icon: <HistoryIcon />,
          },
        ]);
      },
    );
  }
  useEffect(() => {
    fetchAPI();
  }, []);

  return (
    <>
      {get_table_data.map(
        (row: {
          status:
            | 'ON_DELIVERY'
            | 'DELIVERED_BY_RIDER'
            | 'PARTIALLY_DELIVERED_BY_RIDER'
            | 'RETURNED_BY_RIDER'
            | 'DELIVERED'
            | 'RETURNED'
            | 'PARTIALLY_DELIVERED';
          count: number;
          label: string;
          link?: string;
          icon: React.ReactNode; // Add icon type
        }) => (
          <Grid item xs={6} sm={4} md={2} key={row.status}>
            <CounterCard
              label={row.label}
              count={row.count}
              cardClassName={classes[row.status]}
              link={row?.link}
              icon={row.icon} // Pass icon prop
            />
          </Grid>
        ),
      )}
    </>
  );
}
